var pagination = {
	backwardText: "이전 페이지",
	forwardText: "다음 페이지",
	pageRangeText: "{total} 페이지 중 {current} 페이지",
	itemsPerPageText: "페이지당 항목 수",
	itemRangeText: "{start}-{end} / {total} 개 항목",
	pageNumberText: "현재 페이지"
};
var searchPlaceholder = "검색...";
var koTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { koTranslations as default, pagination, searchPlaceholder };
